var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8L0.364 7.5248C1.564 5.9528 4.924 1.7584 5.3384 1.1152C5.8488 0.32 6.72 0 6.9536 0H10.7832C13.8224 1.1552 16 4.2744 16 7.9408C16 11.7408 13.66 14.9528 10.4472 16H6.9536C6.7464 16 5.8488 15.68 5.3384 14.8848C4.9264 14.2448 1.5784 10.064 0.3712 8.4848L0 8Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/Channel.f13dfa8642d91635063158223750538e.svg";
export { ForwardRef as ReactComponent };